import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { Season, Localized } from '../../../../objects';
import { SeasonEditComponent } from '../season-edit/season-edit.component';

@Component({
  selector: 'app-season',
  templateUrl: './season.component.html',
  styleUrls: ['./season.component.css']
})
export class SeasonComponent implements OnInit {

  public data: Season[];
  public isLoading = false;

    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService
    ) { }

    ngOnInit() {
      this.loadElements();

    }

    private loadElements() {
      this.isLoading = true;
      this.apiSvc.get("api/Season/", null).subscribe(
        (data: Season[]) => {
          this.data = data;
          console.log(this.data);
          this.isLoading = false;
        },
        (err) => {
          console.log("error", err);
          this.isLoading = false;
        }
     );
    }

    public add() {
      // const dialogRef = this.dialog.open(ReligionBranchEditComponent, {});
    }

    public edit(obj: Season) {

      var modal = this.dialog.open(SeasonEditComponent);
      modal.componentInstance.LoadItem(obj.Id);

      modal.afterClosed().subscribe((savedItem: Season) => {

        console.log("modal closed", savedItem);

        if (savedItem !== undefined) {
           this.loadElements();
        }

      });

    }

    public delete(obj) {
       alert("Delete");
    }

  }
